module.exports = __webpack_public_path__ + "a125e8ba5fd6fcc548435923582784fa.svg";